// Keep in sync with app/lib/enums/catalog_import_step_status.py
export const CatalogImportStepStatus = {
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  SKIPPED: 'SKIPPED',
};

// Configuration for displaying step statuses in the UI
export const CatalogImportStepStatusConfig = {
  [CatalogImportStepStatus.PENDING]: { variant: 'secondary', text: 'Pending' },
  [CatalogImportStepStatus.IN_PROGRESS]: { variant: 'primary', text: 'In Progress' },
  [CatalogImportStepStatus.COMPLETED]: { variant: 'success', text: 'Completed' },
  [CatalogImportStepStatus.FAILED]: { variant: 'danger', text: 'Failed' },
  [CatalogImportStepStatus.SKIPPED]: { variant: 'warning', text: 'Skipped' },
};

// Keep in sync with app/lib/enums/catalog_import_step_status.py
export const CatalogImportWorkflowStatus = {
  NOT_STARTED: 'not_started',
  PENDING: 'pending',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  FAILED: 'failed',
};

// Configuration for displaying workflow status in the UI
export const CatalogImportWorkflowStatusConfig = {
  [CatalogImportWorkflowStatus.NOT_STARTED]: {
    variant: 'secondary',
    text: 'Workflow not started',
  },
  [CatalogImportWorkflowStatus.PENDING]: {
    variant: 'warning',
    text: 'Workflow is pending',
  },
  [CatalogImportWorkflowStatus.IN_PROGRESS]: {
    variant: 'info',
    text: 'Workflow is in progress',
  },
  [CatalogImportWorkflowStatus.COMPLETED]: {
    variant: 'success',
    text: 'Workflow completed successfully',
  },
  [CatalogImportWorkflowStatus.FAILED]: {
    variant: 'danger',
    text: 'Workflow has failed steps',
  },
};
